module.exports = __webpack_public_path__ + "static/media/travertino.002cc935.jpg";